import User01 from './01.jpg';
import User02 from './02.jpg';
import User03 from './03.jpg';
import User04 from './04.jpg';
import User05 from './05.jpg';
import User06 from './06.jpg';
import User07 from './07.jpg';
import User08 from './08.jpg';
import User09 from './09.jpg';
import User1 from './1.jpg';
import User10 from './10.jpg';
import User11 from './11.jpg';
import User12 from './12.jpg';
import User13 from './13.jpg';
import User14 from './14.jpg';
import User15 from './15.jpg';
import User16 from './16.jpg';
import User17 from './17.jpg';
import User18 from './18.jpg';
import User19 from './19.jpg';

export {
	User1,
	User01,
	User02,
	User03,
	User04,
	User05,
	User06,
	User07,
	User08,
	User09,
	User10,
	User11,
	User12,
	User13,
	User14,
	User15,
	User16,
	User17,
	User18,
	User19,
};
